import React from 'react'
import { getCurrentUser } from 'openstack/helpers'
import { deleteVirtualMachine } from './actions'
import { hasOtherUserVm } from './helpers'
import CustomDeleteDialog from 'core/components/CustomDeleteDialog'

const DeleteVirtualMachineDialog = (props) => {
  const { role: userRole, userId } = getCurrentUser()
  const { rows, onDeleteSuccess } = props

  return (
    <CustomDeleteDialog
      {...props}
      deleteAction={deleteVirtualMachine}
      title="Delete Virtual Machine(s)"
      resourceLabel="VM instance(s)"
      showInfo={userRole === 'member' && hasOtherUserVm({ vms: rows, userId })}
      infoMessage="NOTE: You are performing an operation on another user's VM."
      onDeleteSuccess={onDeleteSuccess}
    />
  )
}

export default DeleteVirtualMachineDialog
